var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdBack = function SvgIdBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ID_Back_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ID_Back_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 7,
    y: 31,
    width: 45,
    height: 49,
    rx: 2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 56,
    cy: 19,
    r: 18,
    stroke: "#000",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -4,
    y: 19,
    width: 66.667,
    height: 51.667,
    rx: 3,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 22a3 3 0 0 1 3-3h60.667a3 3 0 0 1 3 3v39a3 3 0 0 1-3 3H-1a3 3 0 0 1-3-3V22Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-9 41h62M-4 47.5h46M-4 54.5h47",
    stroke: "#A79378",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgIdBack;